import React, { useState, useRef, useCallback, useEffect } from "react";

import "react-toastify/dist/ReactToastify.css";
import AutoExpandingTextbox from "../components/AutoExpandingTextbox";

var Modal = require("react-bootstrap-modal");

export const Details = ({
  onNext,
  onPrev,
  className,
  formData,
  setFormData,
  save,
  updating,
}) => {
  const [stepForm, setStepForm] = useState({
    listingName: formData.listingName,
    aboutListing: formData.aboutListing,
    transportation: formData.transportation,
    parking: formData.parking,
  });

  const [textUpdateKey, setUpdateKey] = useState(1)

  const valueRef = useRef(formData);

  const elementRef = useRef(null);
  

  useEffect(() => {
    valueRef.current = {...formData}
  }, [formData])

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;
    
    const observer = new MutationObserver(() => {
      if (element.classList.contains('tw-hidden')) {
        handleComponentDisappear();
      } else {
        setUpdateKey(-setUpdateKey)
      }
    });
    
    observer.observe(element, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    return () => observer.disconnect();
  }, []);

  const handleComponentDisappear = () => {
    setFormData(valueRef.current);
  };

  const getFile = (e) => {
    setStepForm({ ...stepForm, file: e.target.files[0] });
  };

  const handleStep = (tag, value) => {
    setStepForm({ ...stepForm, [tag]: value });
    valueRef.current = { ...formData, ...stepForm, [tag]: value }
  };

  const handleNextStep = (e) => {
    e.preventDefault();
    setFormData(valueRef.current);
    setTimeout(() => {
      save(stepForm);
      onNext();
    }, 0); 
  };

  return (
    <form onSubmit={handleNextStep} className={className} ref={elementRef}>
      <div className={`tw-min-h-[60vh]`}>
        <div className={`row`}>
          <h4 className="mb-5 tw-flex tw-justify-start tw-items-center">
            <span className="tw-bg-[#23426e] tw-mr-2 tw-flex tw-justify-center tw-items-center  tw-h-10 tw-w-10 tw-text-white  tw-rounded-full">
              2
            </span>{" "}
            Details
          </h4>
          <div className="col-lg-6 mb-2">
            <div className="mb-3">
              <label className="text-label form-label">Listing Name</label>
              <input
                type="text"
                value={stepForm["listingName"]}
                onChange={(e) => handleStep("listingName", e.target.value)}
                name="listingName"
                className="form-control"
                placeholder="Listing Name"
                required
              />
            </div>
          </div>

          <div className="col-lg-6 mb-2">
            <div className="mb-3">
              <label className="text-label form-label">Transportation</label>
              <input
                value={stepForm["transportation"]}
                onChange={(e) => handleStep("transportation", e.target.value)}
                type="text"
                name="transportation"
                className="form-control"
                placeholder="Enter Something"
                required
              />
            </div>
          </div>
          <div className="col-lg-6 mb-2">
            <div className="mb-3">
              <label className="text-label form-label">Parking</label>
              <input
                value={stepForm["parking"]}
                onChange={(e) => handleStep("parking", e.target.value)}
                type="text"
                name="parking"
                className="form-control"
                placeholder="Enter Something"
                required
              />
            </div>
          </div>
          <div className="col-lg-6 mb-2">
            <div className="mb-3">
              <label className="text-label form-label">Summary</label>
              <AutoExpandingTextbox 
                onChange={function(e) {
                  handleStep("aboutListing", e.target.value);
                }}
                value={stepForm["aboutListing"]} 
                placeholder="Summary" 
                type="aboutListing"
                required
                minHeight={44}
                updateKey={textUpdateKey}
              />
            </div>
          </div>
          {/* <div className="col-lg-6 mb-2">
              <div className="mb-3">
                <label className="text-label form-label">Bathrooms</label>
                <input
                  value={stepForm["bathrooms"]}
                  onChange={(e) => handleStep("bathrooms", e.target.value)}
                  type="text"
                  name="bathrooms"
                  className="form-control"
                  placeholder="Enter Something"
                  required
                />
              </div>
            </div> */}
          {/* <div className="col-lg-12 mb-2">
              <div className="mb-3">
                <label className="text-label form-label">Add Photos</label>
                <input
                  type="file"
                  name="transportation"
                  className="form-control"
                  placeholder="Enter Something"
                  onChange={getFile}
                  required
                />
              </div>
            </div> */}
        </div>
      </div>
      <div>
        <button
          onClick={onPrev}
          type="button"
          className="btn btn-secondary mx-2 tw-mb-2"
        >
          Prev
        </button>

        <button
          type="submit"
          disabled={updating}
          className="btn btn-secondary tw-mb-2"
        >
          {updating ? "Updating ..." : "Save & Next"}
        </button>
      </div>
    </form>
  );
};

export const validateDetailsForm = (formData) => {
  const errors = [];

  if (!formData.listingName || formData.listingName.trim() === '') {
    errors.push({
      errorType: 'listingName',
      error: 'Listing Name is required'
    });
  }

  if (!formData.transportation || formData.transportation.trim() === '') {
    errors.push({
      errorType: 'transportation',
      error: 'Transportation is required'
    });
  }

  if (!formData.parking || formData.parking.trim() === '') {
    errors.push({
      errorType: 'parking',
      error: 'Parking is required'
    });
  }

  if (!formData.aboutListing || formData.aboutListing.trim() === '') {
    errors.push({
      errorType: 'aboutListing',
      error: 'Summary is required'
    });
  }

  return {isValid: errors.length === 0, errors};
};